import { Checkbox, Field, TextOutput } from 'Components/Core';
import { Cycle } from 'Components/Worksheets/PlateLoadingWorksheet/types';
import { pipe } from 'ramda';
import { useSelector } from 'react-redux';
import { valueOrDefault } from '../../../../../../Lib/Any';
import deepEquals from '../../../../../../Lib/Object/deepEquals';
import { NamePrefixModifier, withInjectedProps } from '../../../../../Core/InjectedPropsContext';
import { ListFieldSection } from '../../../../../Layout';
import { IWorksheetComponent } from '../../../../Core';

let ResultsSectionBase: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const cycles: Cycle[] = useSelector(pipe(createWorksheetSelector!('Results.Cycles'), valueOrDefault([])), deepEquals);

  const cycleFields = (index: number) => {
    return (
      <>
        <Field input={<TextOutput />} name="MaximumDeformation" />
        <Field input={<Checkbox />} name="CalculateEquivalentCBR" />
        {cycles.length > 0 && cycles[index].CalculateEquivalentCBR && (
          <>
            <Field input={<TextOutput />} name="PressureCBRSettlement" />
            <Field input={<TextOutput />} name="ModulusOfSubgradeReaction" />
            <Field input={<TextOutput />} name="EquivalentCBR" />
          </>
        )}
      </>
    );
  };

  return (
    <NamePrefixModifier appendNamePrefix="Results">
      <ListFieldSection>
        <Field input={<TextOutput />} name="MaximumAppliedPressure" />
        <Field input={<TextOutput />} name="MoistureContent" />
        {cycles.length === 1 && (
          <NamePrefixModifier appendNamePrefix={`Cycles[0]`}>{cycleFields(0)}</NamePrefixModifier>
        )}
      </ListFieldSection>

      {cycles.length > 1 &&
        cycles.map((_, index) => (
          <NamePrefixModifier key={`Cycles[${index}]`} appendNamePrefix={`Cycles[${index}]`}>
            <ListFieldSection heading={`Cycle ${index + 1}`}>{cycleFields(index)}</ListFieldSection>
          </NamePrefixModifier>
        ))}
    </NamePrefixModifier>
  );
};

const ResultsSection = withInjectedProps(ResultsSectionBase);

export default ResultsSection;
export { ResultsSection };
